export const blockIconsAndroidBluetoothNew = (
	<span className='material-symbols-outlined'>bluetooth</span>
);
